export function setQueryString(route, params) {
    // Remove ref
    route = {...route};
    const esc = encodeURIComponent;
    const query = '?' + Object.keys(params)
        .map(k => esc(k) + '=' + esc(params[k]))
        .join('&');
    route.endPoint = route.endPoint + query;
    return route;
}

export function getLoggedUser() {
  const user = localStorage.getItem('_USER');
    return JSON.parse(user);
}

export function setLoggedUser(user) {
  if (user && user.role != 'MARQUE') setDefaultInstitut(user);
  user = JSON.stringify(user);
  localStorage.setItem('_USER', user);
}
export function setDefaultMarque(marque_id) {
  if (marque_id)
    localStorage.setItem('_DEFAULT_MARQUE', marque_id);
  else
    localStorage.removeItem('_DEFAULT_MARQUE');
}
export function getDefaultMarque() {
  return localStorage.getItem('_DEFAULT_MARQUE');
}

export function setDefaultInstitut({ instituts }) {
  const { institut_id } = instituts[0] || 0;
  localStorage.setItem('_DEFAULT_INSTITUT', institut_id);
}

export function getJWTToken() {
  return localStorage.getItem('_JWT');
}

export function setJWTToken(token) {
  localStorage.setItem('_JWT', token);
}

export function isLargeScreen(){
  return window.innerWidth>1000
}

export function generateOptions (list,attribut="nom", value){
  //let options = [{ value: 0, text: 'Sélectionner tout', item:'' }];
  let options = [];
  list.forEach((elem, index) => {
    if((options.filter(unit=>unit.text===elem[attribut])).length===0)
      if (value)
        options.push({value: elem[value], text: elem[attribut], item: elem})
    else
        options.push({value: index, text: elem[attribut], item: elem})
  });
  return options;
}

export function removeReference(variable) {
  return JSON.parse(JSON.stringify(variable));
}
